import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock, Loader2, ShieldCheck } from "lucide-react";

export default function RenewGate({ sub }) {
  const [loading, setLoading] = useState(false);
  const price = sub?.price ?? 2500;

  const renew = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossibile avviare il pagamento");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center" data-testid="renew-gate">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-navy">
          <Lock className="h-8 w-8 text-gold" />
        </div>
        <h1 className="mt-6 font-head text-2xl font-bold text-navy">Rinnova per continuare</h1>
        <p className="mt-3 text-sm text-slate-500">
          Il tuo abbonamento è scaduto. I tuoi dati sono al sicuro e li ritroverai tutti subito dopo il rinnovo.
        </p>
        <div className="mt-6 rounded-xl bg-[#F4F1EA] p-5">
          <div className="font-head text-3xl font-bold text-navy">€{price.toLocaleString("it-IT")}</div>
          <div className="text-xs text-slate-500">per una stagione</div>
        </div>
        <button
          data-testid="renew-now-btn"
          onClick={renew}
          disabled={loading}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-gold py-3.5 font-bold text-black transition-colors hover:bg-gold-hover disabled:opacity-60"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <ShieldCheck className="h-5 w-5" />} Rinnova ora
        </button>
        <p className="mt-3 text-xs text-slate-400">Pagamento sicuro con Stripe</p>
      </div>
    </div>
  );
}
